import { Modal } from "antd";
import { HStack, Checkbox, Text } from "@chakra-ui/react";
import Field from "components/Input/Field";
import FooterModal from "ui/components/Button/FooterModal";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import { useForm } from "react-hook-form";
import useUpdateFinancialCategory from "features/condominio/hooks/useUpdateFinancialCategory";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import SelectCentroDeCusto from "../../../../../../../components/Input/SelectCentroDeCusto/index";

interface EditarPlanoModalProps {
  visible: boolean;
  onClose: () => void;
  defaultCategoria?: Partial<CategoriaFinanceiraItem>;
}

interface FinancialCategoryEdit {
  nome: string;
  codigoIntegracao?: string | null;
  centroDeCustoId?: string | null;
  podeClassificarConta: boolean | null;
  ativo?: boolean | null;
}

export default function EditarPlanoModal({
  onClose,
  visible,
  defaultCategoria,
}: EditarPlanoModalProps) {
  const { tenant } = useCurrentTenant();

  const { control, getValues, trigger, setValue } =
    useForm<FinancialCategoryEdit>({
      defaultValues: defaultCategoria,
    });
  const { mutate, isLoading: isUpdating } = useUpdateFinancialCategory(
    tenant.id
  );
  async function handleSubmit() {
    const pass = await trigger();
    const breadcrumb = defaultCategoria?.breadcrumb!;

    if (pass) {
      mutate(
        {
          ...defaultCategoria,
          nome: getValues("nome"),
          codigoIntegracao: getValues("codigoIntegracao"),
          podeClassificarConta: getValues("podeClassificarConta"),
          ativo: getValues("ativo"),
          centroDeCustoId: getValues("centroDeCustoId"),
          ordem: breadcrumb
            ? parseInt(breadcrumb?.[breadcrumb?.length - 1]) - 1
            : 0,
        },
        { onSuccess: onClose }
      );
    }
  }
  return (
    <Modal
      destroyOnClose
      width="700px"
      footer={
        <FooterModal
          registerAnother={false}
          setRegisterAnother={() => null}
          onSubmit={handleSubmit}
          isLoadingSave={isUpdating}
          onClose={onClose}
          showRegisterAnother={false}
          primaryButtonText="Salvar"
          buttonCancelarText="Cancelar"
        />
      }
      centered
      bodyStyle={{
        borderRadius: 16,
      }}
      title={"Editar conta categoria"}
      visible={visible}
      onCancel={onClose}
      closable={true}
    >
      <HStack spacing="1rem">
        <Field
          label={"Nome"}
          control={control}
          name={"nome"}
          rules={{ required: "Nome é obrigatório." }}
        />
        <Field
          label={"Código de integração"}
          control={control}
          name={"codigoIntegracao"}
          inputProps={{ maxLength: 30 }}
          // rules={{ required: "Código é obrigatório." }}
        />
      </HStack>
      <HStack spacing="1rem">
        <Field
          shouldUnregister
          control={control}
          name="centroDeCustoId"
          label={"Centro de Custo"}
          rules={{
            required: false,
          }}
          render={({ field, isInvalid }) => (
            <SelectCentroDeCusto
              isInvalid={isInvalid}
              onChange={(v) => {
                setValue("centroDeCustoId", v);
              }}
              value={getValues("centroDeCustoId")}
            />
          )}
        />
      </HStack>
      <Field
        control={control}
        name={"podeClassificarConta"}
        render={({ field }) => (
          <HStack
            mt="1.5rem"
            onClick={() => field.onChange(!field.value)}
            spacing="1rem"
          >
            <Checkbox isChecked={!!field.value} />
            <Text size="14px">
              Pode ser utilizada para classificar uma conta
            </Text>
          </HStack>
        )}
      />
      <Field
        control={control}
        name={"ativo"}
        render={({ field }) => (
          <HStack
            mt="1.5rem"
            onClick={() => field.onChange(!field.value)}
            spacing="1rem"
          >
            <Checkbox isChecked={!!field.value} />
            <Text size="14px">Ativo?</Text>
          </HStack>
        )}
      />
    </Modal>
  );
}
